function knuthShuffle(sourceArray, ignoredIndices) {
  for (let n = 0; n < sourceArray.length - 1; n++) {
    if (ignoredIndices == null ? void 0 : ignoredIndices.has(n)) {
      continue;
    }
    const remainingIndices = new Array(sourceArray.length - 1 - n).fill(void 0).map((_, index) => index + n + 1).filter((it) => !(ignoredIndices == null ? void 0 : ignoredIndices.has(it)));
    const k = remainingIndices[Math.floor(Math.random() * remainingIndices.length)];
    if (k === void 0) {
      return sourceArray;
    }
    const temp = sourceArray[k];
    sourceArray[k] = sourceArray[n];
    sourceArray[n] = temp;
  }
  return sourceArray;
}

export { knuthShuffle };
//# sourceMappingURL=array.knuth-shuffle.js.map
